<template>
  <transition name="fade-scale">
    <div class="ai-dialog" v-if="showAiDialog">
      <div class="ai-dialog-header">
      <p>{{ $t('אפשרויות שיפור') }}</p>
      <close-btn @click="close"></close-btn>
    </div>
    <div class="ai-dialog-tabs">
      <div class="tabs">
        <button
            class="tab-button"
            :class="{ active: activeTab === 'image' }"
            type="button"
        >
          <fp-icon symbol="image-gallery"></fp-icon>
          <span>
            <span>תמונה</span>
            <span>צלם תמונת AI סטטית</span>
          </span>
        </button>
        <button
            class="tab-button"
            :class="{ active: activeTab === 'animation' }"
            type="button"
        >
          <fp-icon symbol="video-cam"></fp-icon>
          <span>
            <span>אנימציה</span>
            <span>צלם וידיאו AI מונפש</span>
          </span>
        </button>
        <div class="tab-indicator" :style="indicatorStyle"></div>
      </div>
    </div>
    <div class="ai-dialog-body" v-if="currentSnapshot">
      <div v-if="currentAiGeneratedSnapshot" class="snapshot-frame">
        <div class="snapshot-container">
          <img :src="currentAiGeneratedSnapshot" alt="Current Snapshot" />
        </div>
      </div>
      <div v-else class="snapshot-frame">
        <div class="snapshot-container">
          <img :src="currentSnapshot" alt="Current Snapshot" />
        </div>
      </div>
      <div class="prompts-container">
        <div v-if="loading" class="loading-prompts">
          <span>{{ $t('טוען...') }}</span>
        </div>
        <div v-else-if="currentAiGeneratedSnapshot && !upgrade" class="image-actions">
          <button class="outlined-button" type="button" @click="downloadAiGeneratedImage">הורד</button>
          <button class="full-btn" type="button" @click="currentAiGeneratedSnapshot = null"><fp-icon symbol="ai-sparkles"></fp-icon>צור גירסה נוספת</button>
          <button class="outlined-button" type="button" @click="upgrade = true">שדרג</button>
        </div>
        <div v-else-if="upgrade" class="custom-prompt-container">
          <div class="custom-prompt-header">
            <div class="current-view-info">
              <div class="image-icon-wrapper">
                <fp-icon symbol="image-gallery" size="20"></fp-icon>
              </div>
              <div class="text-info">
                <span class="talking-about">{{ $t('מדבר על התצוגה הנוכחית') }}</span>
                <span class="ai-image">AI Image</span>
              </div>
            </div>
            <button class="close-upgrade" @click="upgrade = false">
              <fp-icon symbol="times" size="14"></fp-icon>
            </button>
          </div>
          <div class="custom-prompt-input-wrapper">
            <input
                v-model="customPrompt"
                :placeholder="$t('תאר מה תרצה לשנות...')"
                @keyup.enter="handleCustomGenerate"
                :disabled="generating"
            />
            <button @click="handleCustomGenerate" :disabled="!customPrompt || generating" class="send-btn">
              <fp-icon symbol="arrow-left" size="20"></fp-icon>
            </button>
          </div>
        </div>
        <div v-else class="prompts-grid">
          <button
            v-for="prompt in prompts"
            :key="prompt"
            @click="generate(prompt)"
            class="outlined-button"
            :disabled="generating"
          >
            <fp-icon symbol="sparkles"></fp-icon>
            {{ prompt }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="generating" class="generating-overlay"></div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import CloseBtn from "@/components/buttons/CloseBtn";
import http from "@/http";
import FpIcon from "@/components/FpIcon.vue";

export default {
  name: 'AiDialog',
  components: {
    FpIcon,
    CloseBtn
  },
  data() {
    return {
      prompts: [],
      loading: false,
      generating: false,
      activeTab: 'image',
      hoverTabIndex: -1,
      currentAiGeneratedSnapshot: null,
      upgrade: false,
      promptKey: '',
      customPrompt: '',
    };
  },
  computed: {
    ...mapGetters('aIAgent', ['showAiDialog', 'currentSnapshot']),
    indicatorStyle() {
      const index = this.hoverTabIndex !== -1 
        ? this.hoverTabIndex 
        : (this.activeTab === 'image' ? 0 : 1);
      return {
        right: `${index * 50}%`,
        width: '50%',
      };
    }
  },
  watch: {
    showAiDialog(val) {
      if (val) {
        this.fetchPrompts();
      }
    },
  },
  methods: {
    async fetchPrompts() {
      this.loading = true;
      try {
        const response = await http.get('ai/prompts');
        this.prompts = response.data;
      } catch (error) {
        console.error('Failed to fetch AI prompts', error);
      } finally {
        this.loading = false;
      }
    },
    async generate(prompt) {
      this.promptKey = prompt;
      this.generating = true;
      this.$store.commit('aIAgent/aiProcessing', true);
      try {
        const blob = this.upgrade ? await this.dataURLtoBlob(this.currentAiGeneratedSnapshot) : await this.dataURLtoBlob(this.currentSnapshot);
        const formData = new FormData();
        formData.append('promptKey', prompt);
        formData.append('image', blob, 'snapshot.png');
        if(this.customPrompt){
          formData.append('customPrompt', this.customPrompt);
        }

        const response = await http.post('ai/generate', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (response.data && response.data.image) {
          this.$store.dispatch('aIAgent/addToImagesLibrary', response.data.image);
          let image = response.data.image;
          if(!image.startsWith('data:image/png;base64,')){
            image = 'data:image/png;base64,' + image
          }
          this.currentAiGeneratedSnapshot = image;
          //this.$store.commit('aIAgent/previewingImage', response.data.image);
          //this.$store.commit('aIAgent/showAiDialog', false);
          //this.$store.commit('aIAgent/showAiImagesLibrary', true);
        }
      } catch (error) {
        console.error('Failed to generate AI image', error);
      } finally {
        this.generating = false;
        this.upgrade = false;
        this.$store.commit('aIAgent/aiProcessing', false);
      }
    },
    async listModels(){
      const response = await http.get('ai/models');
      console.log({
        response
      })
    },
    close() {
      this.currentAiGeneratedSnapshot = null;
      this.$store.commit('aIAgent/showAiDialog', false);
    },
    openLibrary() {
      this.$store.commit('aIAgent/showAiImagesLibrary', true);
    },
    handleCustomGenerate() {
      if (this.promptKey && this.customPrompt && !this.generating) {
        this.generate(this.promptKey);
        this.customPrompt = '';
      }
    },
    async dataURLtoBlob(dataurl) {
      const res = await fetch(dataurl);
      return await res.blob();
    },
    downloadAiGeneratedImage(){
      const link = document.createElement('a');
      link.href = this.currentAiGeneratedSnapshot;
      link.download = `ai-image-${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
};
</script>

<style scoped lang="scss">
.ai-dialog {
  position: fixed;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  background-color: #0e1725;
  border-radius: 12px;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  border: solid 1px #212c3b;

  &.fade-scale-enter-active,
  &.fade-scale-leave-active {
    transition: all 0.3s ease;
  }

  &.fade-scale-enter-from,
  &.fade-scale-leave-to {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }

  /*.ai-dialog-tabs {
  }*/

  .ai-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: solid 1px #212c3b;

    /*.full-btn {
      background: var(--primary, #00C3B8);
      border: none;
      color: white;
      padding: 5px 20px;
      border-radius: 20px;
      cursor: pointer;
      font-size: 0.9rem;
      transition: all 0.2s ease;
      box-shadow: 0 4px 0 var(--primary-darker, #005C57);

      &:hover {
        background: var(--primary-dark, #019F95);
      }

      &:active {
        box-shadow: 0 2px 0 var(--primary-darker, #005C57);
        transform: translateY(2px);
      }
    }*/
  }

  .full-btn {
    background-color: oklch(0.715 0.143 215.221);
    color: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0.1) 0 10px 15px -3px, rgba(0, 0, 0, 0.1) 0 4px 6px -4px; /* Matches shadow-lg */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    white-space: nowrap;
    font-weight: 500;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    outline: 2px solid transparent;
    outline-offset: 2px;
    border-radius: 0.375rem;
    padding-left: 1.8rem;
    padding-right: 1.8rem;
    min-height: 2.5rem;
    font-size: 1.25rem;
    &:hover {
      background-color: oklch(0.665 0.158 217.42);
    }

    svg {
      fill: none;
      stroke: #fff;
    }
  }

  .ai-dialog-body {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    overflow-y: auto;
  }

  @keyframes pulse-shadow {
    0% {
      box-shadow: rgba(6, 182, 212, 0.60) 0 0 29px;
    }
    100% {
      box-shadow: rgba(6, 182, 212, 0.40) 0 0 24px;
    }
  }

  .snapshot-frame {
    background-color: #19222e;
    border-radius: 14px;
    margin-inline: 40px;
  }

  .snapshot-container {
    width: calc(100% - 60px);
    margin: 30px;
    border: solid 2px var(--primary);
    border-radius: 14px;
    overflow: hidden;
    animation: pulse-shadow 2s ease-in-out infinite alternate;

    img {
      width: 100%;
      border-radius: 8px;
      object-fit: cover;
      max-height: 40vh;
    }
  }

  .prompts-container {
    .prompts-grid {
      display: flex;
      justify-content: start;
      flex-flow: row wrap;
      gap: 15px;
      margin-bottom: 20px;
      padding-inline: 40px;
    }

    .outlined-button {
      padding: .5rem 1rem;
      border-radius: 1rem;
      text-align: start;
      transition: all 150ms ease-in-out;
      color: #fff;
      background-color: rgba(6, 182, 212, 0.2);
      border: 2px solid #06b6d4;
      box-shadow: 0 10px 15px -3px rgba(6, 182, 212, 0.3),
      0 4px 6px -2px rgba(6, 182, 212, 0.05);
      cursor: pointer;
      font-size: .8rem;
      display: inline-flex;
      gap: 0.5rem;
      align-items: center;
      svg {
        fill: #fff;
        stroke: #fff;
      }
    }

    .outlined-button:hover {
      /* Copy the styles that change when :hover IS active */
      /* Example: */
      background-color: rgba(
              10, 200, 220, 0.3
      ); /* A slightly different background on hover */
      border-color: #0bd4f0; /* A slightly different border on hover */
      box-shadow: 0 12px 17px -4px rgba(6, 182, 212, 0.4),
      0 6px 8px -3px rgba(6, 182, 212, 0.1); /* A slightly more pronounced shadow */
    }
  }

  .generating-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    z-index: 10;
    color: white;
    gap: 20px;
  }

  .tabs {
    display: flex;
    position: relative;
    border-bottom: 2px solid rgba(82, 173, 189, 0.1);
  }

  .tab-indicator {
    position: absolute;
    bottom: 0;
    height: 2px;
    background-color: var(--primary);
    transition: right 0.3s cubic-bezier(0.4, 0, 0.2, 1), left 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
  }

  .tab-button {
    flex: 1 1 0;
    padding: 1rem 1.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    position: relative;
    background-color: #0e1725;
    color: #6a7272;
    font-size: 1rem;
    border: none;
    cursor: pointer;

    svg {
      fill: #6a7272;
      stroke: #6a7272;
      transition-property: all;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    }

    span {
      transition-property: all;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    }

    & > span {
      text-align: start;
      display: flex;
      flex-flow: column;
      gap: 5px;
      & > span:last-child {
        font-size: 0.8rem;
      }
    }

    &:hover {
      background-color: #15202e;
      color: #fff;
    }
    &.active {
      color: var(--primary);
      background-color: #0d2837;
      svg {
        fill: var(--primary);
        stroke: var(--primary);
      }
    }
  }

  .image-actions {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
  }

  .custom-prompt-container {
    background-color: #0e1725;
    border: 1px solid #212c3b;
    border-radius: 12px;
    padding: 15px;
    margin-inline: 40px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    .custom-prompt-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .close-upgrade {
        background: none;
        border: none;
        cursor: pointer;
        padding: 5px;
        color: #6a7272;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .current-view-info {
        display: flex;
        align-items: center;
        gap: 10px;
        text-align: right;

        .text-info {
          display: flex;
          flex-direction: column;

          .talking-about {
            color: var(--primary);
            font-size: 0.9rem;
            font-weight: 500;
          }

          .ai-image {
            color: #fff;
            font-size: 0.8rem;
          }
        }

        .image-icon-wrapper {
          background: rgba(0, 195, 184, 0.1);
          border: 1px solid var(--primary);
          border-radius: 8px;
          padding: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--primary);
          svg {
            fill: var(--primary);
            stroke: var(--primary);
          }
        }
      }
    }

    .custom-prompt-input-wrapper {
      display: flex;
      align-items: center;
      background: #15202e;
      border: 1px solid #212c3b;
      border-radius: 20px;
      padding: 5px 15px;
      gap: 10px;

      input {
        flex: 1;
        background: none;
        border: none;
        color: #fff;
        padding: 10px 0;
        outline: none;
        font-size: 1rem;
        text-align: right;

        &::placeholder {
          color: #6a7272;
        }
      }

      .send-btn {
        background: var(--primary);
        border: none;
        border-radius: 8px;
        padding: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;

        &:disabled {
          background: #212c3b;
          cursor: not-allowed;
        }

        &:hover:not(:disabled) {
          filter: brightness(1.1);
        }

        svg {
          fill: #fff;
          stroke: #fff;
        }
      }
    }
  }
}

@media (max-width: 600px) {
    .ai-dialog {
        width: 95vw;
        padding: 15px;
    }
    .prompts-grid {
        grid-template-columns: 1fr 1fr !important;
    }
}
</style>
